import { Button, Modal, Typography, Box, Divider } from "@mui/material";
import styles from "./ConfirmationModal.module.scss";
import { useTranslation } from "react-i18next";
import { TiTick } from "react-icons/ti";
import { AiFillCheckCircle } from "react-icons/ai";
import { FaExclamationTriangle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import PDFBtnReceipt from "./pdf/PDFBtnReceipt";
import { BsExclamationCircleFill } from "react-icons/bs";

import React, { useState } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",

  pt: 2,
  px: 4,
  pb: 3,
};

function ChildModal(props) {
  const { onSubmit, message, eventId } = props;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button variant="outlined" onClick={handleOpen}>
        Return to main page
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style, width: "fit-content", borderRadius: 3 }}>
          <Box className={styles.allertImg}>
            <BsExclamationCircleFill size={30} color="#FFCC00" />
          </Box>
          <Box sx={{ textAlign: "center", marginBottom: 1 }}>
            <Typography fontWeight={700} fontSize={20}>
              You are about to exit this page
            </Typography>
          </Box>
          <Box maxWidth={"280px"}>
            <Typography textAlign={"center"} fontWeight={600}>
              {message}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              gap: 1,
              justifyContent: "center",
              marginTop: 2,
            }}
          >
            <Button variant="outlined" onClick={handleClose} color="error">
              Cancel
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                handleClose();
                navigate(`../../${eventId}`, { replace: true });
              }}
              color="success"
            >
              Confirm
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

const ConfirmationModal = (props) => {
  const {
    open,
    handleClose,
    date,
    time,
    skuName,
    price,
    txId,
    eventId,
    paymentName,
    paymentMethod,
    phoneNumber,
    paymentEmail,
  } = props;
  const { t } = useTranslation();
  console.log(paymentEmail);
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <Box className={styles.boxModal}>
        <Box className={styles.successImg}>
          <AiFillCheckCircle size={40} fill="green" />
        </Box>
        <Box textAlign={"center"}>
          <Typography fontSize={24} fontWeight={700}>
            Thank you!
          </Typography>
          <Typography fontSize={16} color="gray">
            Your payment is successfully process
          </Typography>
        </Box>
        <Divider style={{ paddingBlock: 5 }} />
        <Box paddingY={1}>
          <Typography fontSize={18} fontWeight={600}>
            Payment Summary
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography fontSize={16}>Date</Typography>
              <Typography fontSize={14} color={"gray"}>
                {date}
              </Typography>
            </Box>
            <Box>
              <Typography textAlign={"right"} fontSize={16}>
                Time
              </Typography>
              <Typography fontSize={14} color={"gray"}>
                {time}
              </Typography>
            </Box>
          </Box>
          <Divider style={{ marginBlock: 10 }} />
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBlock: 10,
            }}
          >
            <Typography fontSize={16}>Item</Typography>
            <Typography fontSize={14} color={"gray"}>
              {eventId} <br />
              {skuName}
            </Typography>
          </Box>
          <Box display={"flex"} justifyContent={"space-between"} marginY={1}>
            <Typography fontSize={16}>Payee</Typography>
            <Typography fontSize={14} color={"gray"}>
              MyGym Premium
            </Typography>
          </Box>
          <Box display={"flex"} justifyContent={"space-between"} marginY={1}>
            <Typography fontSize={16}>Total Amount</Typography>
            <Typography fontSize={14} color={"gray"}>
              HK${price}
            </Typography>
          </Box>
          <Divider style={{ marginBlock: 10 }} />
          <Box display={"flex"} justifyContent={"space-between"} marginY={1}>
            <Typography fontSize={16}>Transaction ID</Typography>
            <Typography fontSize={14} color={"gray"} fontWeight={600}>
              {txId}
            </Typography>
          </Box>
          <Box
            bgcolor={"#FFCC00"}
            width={"100%"}
            borderRadius={3}
            display="flex"
            alignItems={"center"}
          >
            <Box padding={2}>
              <FaExclamationTriangle size={16} color="white" />
            </Box>
            <Typography
              padding={1}
              fontSize={14}
              color={"white"}
              fontWeight={600}
              lineHeight={"1.2rem"}
            >
              {t("confirmation modal")}
            </Typography>
          </Box>
        </Box>
        <Box
          display={"flex"}
          justifyContent="space-between"
          mt={2}
          className={styles.btnBox}
        >
          {/* <Button variant="outlined">Return to main page</Button> */}
          <PDFBtnReceipt
            txId={txId}
            phoneNumber={phoneNumber}
            fullName={paymentName}
            paymentMethod={paymentMethod}
            email={paymentEmail}
            description={eventId + "\n" + skuName}
            date={date + " - " + time}
            price={price}
          />
          <ChildModal eventId={eventId} message={t("confirmation modal")} />
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
